import toast from "react-hot-toast";

export class EntityBase {
    constructor(data = {}, fieldConfig = {}) {
        for (const key in fieldConfig) {
            const {type, defaultValue} = fieldConfig[key];
            const value = data[key];

            if (value !== undefined && value !== null) {
                if (type === Object) {
                    this[key] = (typeof value === 'object' && !Array.isArray(value)) ? value : JSON.parse(value);
                } else if (type === Array) {
                    if (Array.isArray(value)) {
                        this[key] = value;
                    } else if (typeof value === 'string') {
                        try {
                            this[key] = JSON.parse(value);
                        } catch {
                            this[key] = value.split(',').map(s => s.trim()).filter(Boolean);
                        }
                    } else {
                        this[key] = defaultValue;
                    }
                } else {
                    this[key] = type ? type(value) : value;
                }
            } else {
                this[key] = defaultValue;
            }
        }
        this.errors = [];
    }

    isInvalidate() {
        for (const {condition, message} of this.errors) {
            if (condition()) {
                toast.error(message);
                return true;
            }
        }

        return false;
    }

    toJson() {
        const {errors, ...rest} = this;
        return JSON.parse(JSON.stringify(rest));
    }

    toString() {
        const {errors, ...rest} = this;
        return JSON.stringify(rest);
    }

    getIdentityKey() {
        return 'index';
    }
}